module.exports = __webpack_public_path__ + "static/second_slider-30c3afa9ab95779922eaefebab63fa13.png";